import { api } from './api'

/**
 * Account deletion (tooti#150). Both calls need a fresh code the caller
 * first asks for with `auth.requestOtp` — the same SMS as sign-in.
 */

/** The signed-in learner deletes their own account — `account_delete`. */
export async function deleteOwnAccount(code) {
  const { data } = await api.post('/account/delete', { code })
  return data
}

/** The public path, no session — `account_deleteByPhone`. `{ deleted: false }` when the number has no account. */
export async function deleteAccountByPhone(phone, code) {
  const { data } = await api.post('/account/delete-by-phone', { phone, code })
  return data
}
